import styled from 'styled-components';
import background from '../ModalInfo/Assets/modalInfoBG.jpg';

export const Modal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed; /* melhor que absolute */
  top: 0;
  left: 0;
  z-index: 22;
  background-color: rgba(33,33,33,0.55);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  background-image: url(${background});
  background-size: cover;
  color: black;
  width: 950vw;
  height: 600px; /* default melhor p/ texto longo */
  border-radius: 20px;
  margin-left: 30px;
  margin-right: 30px;

  display: flex;
  flex-direction: column;
  overflow: hidden; /* impede conteúdo vazar */

  h1{
    color:#12d258;
    font-size: 15px;
    line-height: 20px;
    font-weight: bold;
    margin: 18px 30px 8px 30px;
  }

  /* botão X */
  > button{
    border: none;
    outline: none;
    align-self: flex-end;     /* em vez de right calc */
    margin: 12px 12px 0 0;    /* posiciona dentro */
    display: flex;
    align-items: center;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 8px;
    background-color: #4055b1;
    color:#fff;
    font-size: 17px;
    justify-content: center;
    font-weight: bold;
  }

  @media screen and (max-width: 543px) {
    height: 520px;
  }
`;

/* área de conteúdo com scroll */
export const Content = styled.div`
  flex: 1;
  overflow-y: 950vw;
  padding: 0 30px 10px 30px;

  color: #fff;
  font-size: 14px;
  line-height: 20px;
  font-weight: 300;

  p {
    margin: 0 0 12px 0;
  }

  b {
    display: inline-block;
    margin-bottom: 8px;
  }

  ul {
    list-style: disc;
    padding-left: 20px;
    margin: 8px 0 12px 0;
  }

  li {
    margin-bottom: 6px;
  }
`;

export const Footer = styled.footer`
  border-top: solid 1px #333333;
  padding: 14px 20px;

  /* mantém footer sempre visível */
  flex: 0 0 auto;

  div{
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  button{
    border: none;
    cursor: pointer;
    background-color: #12d258;
    border-radius: 12px;
    font-size: 12px;
    padding: 6px 14px;   /* melhor que width/height fixo */
    color: #000;
  }

  p{
    margin: 0;
    font-size: 16px;
    color: #12d258;
    text-decoration: underline;
    cursor: pointer;
  }
`;
